<!--begin::Wrapper-->
<div class="d-flex align-items-baseline" >

  <!--begin::Form-->
  <form class="w-375px me-10 position-relative mb-3" autocomplete="off">
    <!--begin::Icon-->
    <span
      [inlineSVG]="'./assets/media/icons/duotune/general/gen021.svg'"
      class="svg-icon svg-icon-2 svg-icon-lg-1 svg-icon-gray-500 position-absolute top-50 translate-middle-y ms-0"
    ></span>
    <!--end::Icon-->

    <!--begin::Input-->
    <input type="text" class="form-control  ps-10" style="border-radius: 18px" name="search" value="" [placeholder]="'MenuDashboard.searchHolder' | translate" data-kt-search-element="input" (keyup)="handleKeyPress($event)"
    />
    <!-- [ngModel]="keyword" (ngModelChange)="search($event)" -->
    <!--end::Input-->

    <!--begin::Spinner-->
    <span class="position-absolute top-50 end-0 translate-middle-y lh-0 me-1" data-kt-search-element="spinner" [ngClass]="searching.value ? '' : 'd-none'">
        <span class="spinner-border h-15px w-15px align-middle text-gray-400"></span>
    </span>
    <!--end::Spinner-->

    <!--begin::Reset-->
    <span class="btn btn-flush btn-active-color-primary position-absolute top-50 end-0 translate-middle-y lh-0" data-kt-search-element="clear" [ngClass]="searching.value || keyword.length === 0 ? 'd-none' : ''" (click)="clearSearch()">
        <span
          [inlineSVG]="'./assets/media/icons/duotune/arrows/arr061.svg'"
          class="svg-icon svg-icon-2 svg-icon-lg-1 me-0"
        ></span>
    </span>
    <!--end::Reset-->

    <!--begin::Toolbar-->
    <!-- <div class="position-absolute top-50 end-0 translate-middle-y" data-kt-search-element="toolbar" [ngClass]="searching || keyword.length > 0 ? 'd-none' : ''"> -->
    <!--begin::Preferences toggle-->
    <!-- <div data-kt-search-element="preferences-show" class="btn btn-icon w-20px btn-sm btn-active-color-primary me-1" data-bs-toggle="tooltip" title="Show search preferences">
        <span
          [inlineSVG]="'./assets/media/icons/duotune/coding/cod001.svg'"
          class="svg-icon svg-icon-1"
        ></span>
    </div> -->
    <!--end::Preferences toggle-->

    <!--begin::Advanced search toggle-->
    <!-- <div data-kt-search-element="advanced-options-form-show" class="btn btn-icon w-20px btn-sm btn-active-color-primary" data-bs-toggle="tooltip" title="Show more search options">
        <span
          [inlineSVG]="'./assets/media/icons/duotune/arrows/arr072.svg'"
          class="svg-icon svg-icon-2"
        ></span>
    </div> -->
    <!--end::Advanced search toggle-->
    <!-- </div> -->
    <!--end::Toolbar-->
  </form>
  <!--end::Form-->

  <!--begin::Separator-->
  <div class="separator border-gray-200 mb-6"></div>
  <!--end::Separator-->

  <!--begin::Recently viewed-->
  <ng-container *ngIf="new_result$ | async as results">
    <div  class="d-flex flex-column" data-kt-search-element="results" [ngClass]="results?.length===0 ? 'd-none' : ''">
      <!-- <div class="d-flex align-items-stretch bg-gray-200 gap-2 overflow-x-scroll rounded">
        <div *ngFor="let item of resultsCategories" class="flex-grow-1 rounded p-2 text-center fw-bolder text-white bg-primary cursor-pointer" >
          {{'search.'+item.title | translate}} ({{item.nbr}})
        </div>
      </div>     -->
      <!--begin::Items-->
<!--      <div class="scroll-y mh-200px mh-lg-400px mt-2">-->
<!--        &lt;!&ndash;begin::Category title&ndash;&gt;-->
<!--        &lt;!&ndash; <h3 class="fs-5 text-muted m-0 pb-5" data-kt-search-element="category-title">-->
<!--          Users-->
<!--        </h3> &ndash;&gt;-->
<!--        &lt;!&ndash;end::Category title&ndash;&gt;-->

<!--        &lt;!&ndash;begin::Item&ndash;&gt;-->
<!--        <div *ngFor="let item of results" class="d-flex text-dark  align-items-center mb-5">-->
<!--          &lt;!&ndash;begin::Symbol&ndash;&gt;-->
<!--&lt;!&ndash;          <div class="symbol symbol-40px me-4">&ndash;&gt;-->
<!--&lt;!&ndash;            <img lcmsAvatarAsLetter [width]="'35px'" [height]="'35px'" [fontsize]="'12px'"  [email]="item.title" [src]="item?.image" class="rounded-circle" style="width: 35px;height: 35px;" alt=""/>&ndash;&gt;-->
<!--&lt;!&ndash;          </div>&ndash;&gt;-->
<!--          &lt;!&ndash;end::Symbol&ndash;&gt;-->

<!--          &lt;!&ndash;begin::Title&ndash;&gt;-->
<!--          <div class="d-flex flex-column justify-content-start fw-bold">-->
<!--            <span class="fs-6 fw-bold">{{ item.title }}</span>-->
<!--            <a role="button" (click)="navigateWithCategory(item)" class="fs-7 fw-bold text-muted text-hover-primary">{{ 'search.'+item?.category | translate }} ({{item?.nbr}})</a>-->
<!--          </div>-->
<!--          &lt;!&ndash;end::Title&ndash;&gt;-->
<!--        </div>-->
<!--        &lt;!&ndash;end::Item&ndash;&gt;-->
<!--      </div>-->
<!--      <div  class="align-self-center">-->
<!--        <a role="button" (click)="navigateToSearch()" data-kt-menu-trigger="click"  class="link-primary " >-->
<!--          {{'search.show_all_results' | translate}}-->
<!--        </a>-->
<!--      </div>-->
      <!--end::Items-->
    </div>
  </ng-container>
  <!--end::Recently viewed-->

  <!--begin::Recently viewed-->
  <!-- <div data-kt-search-element="results" [ngClass]="keyword.length > 0 ? 'd-none' : ''">
    <div class="scroll-y mh-200px mh-lg-325px">
      <h3 class="fs-5 text-muted m-0 pb-5" data-kt-search-element="category-title">
        Recently Searched
      </h3>
      <a href="#" *ngFor="let item of recentlySearchedModels" class="d-flex text-dark text-hover-primary align-items-center mb-5">
        <div class="symbol symbol-40px me-4">
          <img *ngIf="item.image" src="{{ item.image }}" alt=""/>

          <span class="symbol-label bg-light">
            <span
              *ngIf="item.icon"
              [inlineSVG]="item.icon"
              class="svg-icon svg-icon-2 svg-icon-primary"
            ></span>
          </span>
        </div>
        <div class="d-flex flex-column justify-content-start fw-bold">
          <span class="fs-6 fw-bold">{{ item.title }}</span>
          <span class="fs-7 fw-bold text-muted">{{ item.description }}</span>
        </div>
      </a>
    </div>
  </div> -->
  <!--end::Recently viewed-->
  <div class="w-375px me-10">

    <div  class="h-40px ">

      <ng-container *ngIf="listCategories$ | async as listTag; else loadingusers">
        <lcms-select-filter [isLoading]="categoriesLoad"  (SearchItem)="searchTag($event)" (ScrollToEnd)="tagsloadMor($event)" [title]="'catalogue.tags' | translate" [items]="listTag" (selectedItemsChange)="onSelectedCateChange($event)" >
        </lcms-select-filter>
      </ng-container>
      <ng-template #loadingusers>
        <ngx-shimmer-loading
          [width]="'100%'"
          [height]="'20px'"
        ></ngx-shimmer-loading>
      </ng-template>
    </div>

    <ng-container *ngIf="selectedCategories ">
                            <span *ngFor="let item of selectedCategories  " class="badge badge-light-primary bg-body-secondary mb-2 me-2 mt-3 p-3 w-auto">{{ item?.label }}
                              <a class="cursor-pointer" (click)="removecate(item)">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="currentColor"></rect>
                                        <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="currentColor"></rect>
                                    </svg>
                                </a>
                            </span>
    </ng-container>
  </div>
  <div class="w-375px">
  <div  class="h-40px ">
      <lcms-select-filter [disabled]="searchSerive.searchKeyworld.value===''"  (SearchItem)="searchType($event)"  [title]="'catalogue.type' | translate" [items]="typeCatalogue" (selectedItemsChange)="onSelectedTypeChange($event)" >
      </lcms-select-filter>
  </div>
    <ng-container *ngIf="selectedtype ">
                            <span *ngFor="let item of selectedtype  " class="badge badge-light-primary bg-body-secondary mb-2 me-2 mt-3 p-3 w-auto">{{ item?.label }}
                              <a class="cursor-pointer" (click)="removeType(item)">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="currentColor"></rect>
                                        <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="currentColor"></rect>
                                    </svg>
                                </a>
                            </span>
    </ng-container>
  </div>
  <div>
    <a  class="btn btn-primary py-1 px-2 mx-2" (click)="handleSearchClicked()" >{{'catalogue.search' | translate}}</a>
  </div>
</div>
<!--end::Wrapper-->

